import React from 'react';
import { G, Path, Svg, Circle, Polygon, Rect } from 'react-native-svg';
export const ApplyComplete = () => {
  return /*#__PURE__*/React.createElement(Svg, {
    width: "36px",
    height: "36px",
    viewBox: "0 0 41 46"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Desktop",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Loan-Progress-Completed-Option-02",
    transform: "translate(-113.000000, -248.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Group-7",
    transform: "translate(15.000000, 195.000000)"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Group_379",
    transform: "translate(97.988000, 53.000000)"
  }, /*#__PURE__*/React.createElement(G, {
    id: "Apply---01",
    transform: "translate(0.012000, 0.000000)"
  }, /*#__PURE__*/React.createElement(G, {
    id: "GOLD_CHECK"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M33.5298958,15.5995612 C29.0619857,15.5995612 25.4388371,11.9764125 25.4388371,7.50850247 C25.4388371,7.25891388 25.4525507,7.00932529 25.4744926,6.76522216 C23.7328579,6.27153044 21.8979704,6 20,6 C8.9550192,6 0,14.9550192 0,26 C0,37.0449808 8.9550192,46 20,46 C31.0449808,46 40,37.0449808 40,26 C40,21.9188151 38.7767416,18.1283598 36.6785518,14.9632474 C35.7103675,15.3719144 34.6461876,15.5995612 33.5298958,15.5995612 Z",
    id: "Path",
    fill: "#03906A"
  }), /*#__PURE__*/React.createElement(Circle, {
    id: "Oval",
    fill: "#9E8733",
    cx: "34.0964467",
    cy: "6.9035533",
    r: "6.9035533"
  }), /*#__PURE__*/React.createElement(Polygon, {
    id: "Path",
    fill: "#FFFFFF",
    points: "29.2937394 7.11201354 30.6365482 5.76920474 32.9350254 8.0676819 37.2125212 3.79018613 38.5553299 5.13028765 32.9350254 10.7505922"
  })), /*#__PURE__*/React.createElement(G, {
    id: "ICON_-_APPLY",
    transform: "translate(10.677496, 14.300846)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement(Polygon, {
    id: "Path",
    opacity: "0.2",
    points: "21.8585448 10.3038917 24.2328257 12.6781726 14.3187817 22.8629442 8.53604061 17.080203 11.3001692 14.3160745 14.5516074 17.5675127"
  }), /*#__PURE__*/React.createElement(G, {
    id: "Group"
  }, /*#__PURE__*/React.createElement(G, {
    transform: "translate(0.000000, -0.000000)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M8.31133672,9.77597293 L8.31133672,9.77597293 C7.10930626,9.77597293 5.97766497,9.30761421 5.12758037,8.45482234 C4.27749577,7.60473773 3.80913706,6.47309645 3.80913706,5.27106599 L3.80913706,4.50219966 C3.80913706,3.3001692 4.27749577,2.16852792 5.12758037,1.31844332 C5.97766497,0.468358714 7.10930626,1.92363516e-15 8.31133672,1.92363516e-15 L8.31133672,1.92363516e-15 C10.7939086,1.92363516e-15 12.8135364,2.01962775 12.8135364,4.50490694 L12.8135364,5.27377327 C12.8135364,7.75634518 10.7939086,9.7786802 8.30862944,9.7786802 L8.31133672,9.77597293 Z M8.31133672,1.48087986 C7.50456853,1.48087986 6.7465313,1.79492386 6.17529611,2.36615905 C5.60406091,2.93739425 5.29001692,3.69543147 5.29001692,4.50219966 L5.29001692,5.27106599 C5.29001692,6.93874788 6.64365482,8.29238579 8.31133672,8.29509306 C9.97901861,8.29509306 11.3353638,6.93874788 11.3353638,5.27377327 L11.3353638,4.50490694 C11.3353638,2.83722504 9.97901861,1.48358714 8.31404399,1.48358714 L8.31404399,1.48358714 L8.31133672,1.48087986 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement(Rect, {
    id: "Rectangle",
    x: "3.16751269",
    y: "15.0524535",
    width: "1.48087986",
    height: "6.13468697"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M1.48087986,21.1844332 L0,21.1844332 L0,13.162775 C0,11.3461929 1.15871404,9.74077834 2.88324873,9.16954315 C6.38375635,8.00812183 10.2389171,8.00812183 13.7367174,9.16954315 C14.3648054,9.37800338 14.9414552,9.73536379 15.4043993,10.2064298 L14.351269,11.2460237 C14.0507614,10.9428088 13.6771574,10.7099831 13.2683587,10.5746193 C10.0737733,9.51336717 6.54890017,9.51336717 3.34890017,10.5746193 C2.23079526,10.9455161 1.48087986,11.98511 1.48087986,13.1600677 L1.48087986,21.1817259 L1.48087986,21.1844332 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement(Path, {
    d: "M13.0192893,22.2321489 L6.4893401,15.6994924 L9.71099831,12.4778342 L13.0192893,15.7861252 L19.0592217,9.74619289 L22.2835871,12.9678511 L13.0192893,22.2321489 Z M8.5820643,15.6994924 L13.0192893,20.1367174 L20.1881557,12.9678511 L19.0592217,11.8389171 L13.0192893,17.8788494 L9.71099831,14.5705584 L8.5820643,15.6994924 Z",
    id: "Shape"
  })))))))));
};
//# sourceMappingURL=ApplyComplete.js.map